import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ParamMap } from '@angular/router';
import { InputType } from '@core/models';

import { Block } from '@core/models/block/block.model';
import { FiltersService } from '@shared/services/filters/filters.service';

import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-filter-single-selector',
  styleUrls: ['./filter-single-selector.component.scss'],
  template: `
    <ng-container [formGroup]="formGroup">

      <ng-container *ngIf="_inputType === 'radio' else checkbox ">
        <input #input type="radio" class="cdk-visually-hidden" formControlName="active"/>
      </ng-container>

      <ng-template #checkbox>
        <input #input type="checkbox" class="cdk-visually-hidden" formControlName="active"/>
      </ng-template>

      <div class="filter-single-container"
           [filterActive]="isActive"
           [attr.data-c-id]="_uid">
        <div app-block
             *ngFor="let block of block.children"
             [disableTabIndex]="true"
             [appClickableBlock]="block"
             [filterActive]="isActive"
             [class]="block.uId"
             [ngClass]="classActive(block)"
             [item]="block">
        </div>
      </div>
    </ng-container>
  `,
  host: {
    '(click)': 'onChecked()',
    '[attr.tabindex]': 'block.tabindex >=0 ? block.tabindex : null',
  },
  standalone: false,
})
export class FilterSingleSelectorComponent implements OnInit, OnDestroy {
  formGroup = this._fb.group({
    active: [false],
  });
  @Input() block: Block;
  @ViewChild('input') _inputElement: ElementRef<HTMLInputElement>;
  private _filterSubscription = Subscription.EMPTY;

  constructor(private _fb: UntypedFormBuilder, private fs: FiltersService) {
  }

  get _uid(): string {
    return this.block.uId;
  }

  get classActive() {
    return block => ({
      [block.uId + '__active']: this.isActive,
    });
  }

  get _inputType(): InputType {
    return this.block.settings.inputType;
  }

  get isActive(): boolean {
    return this.formGroup.get('active').value;
  }

  ngOnInit(): void {
    this._filterSubscription =
      this.fs.filtersFrom$
        .pipe(tap((p: ParamMap) => this.updated(p)))
        .subscribe();
  }

  ngOnDestroy(): void {
    this._filterSubscription.unsubscribe();
  }

  onChecked() {
    const checked = this._inputElement.nativeElement.checked;
    this.formGroup.patchValue({active: !checked});
    this.onCheckedChanged();
  }

  onCheckedChanged() {

    const {controlType, category: {id}, inputType} = this.block.settings;
    this.fs.updateParams(this.isActive, controlType, id);
    this.fs.selectLastFilter = controlType;
    if (inputType === 'radio') {
      this.formGroup.patchValue({active: true});
    }
  }

  private updated(params: ParamMap) {
    this.formGroup.patchValue({active: this.checkActivity(params)});
  }

  private checkActivity(params: ParamMap): boolean {
    const {controlType, category: {id}} = this.block.settings;

    const values = params.getAll(controlType);
    const categoryIdString = id.toString();
    return this.isParamsActiveInArray(values, categoryIdString);
  }

  private isParamsActiveInArray(values: string[], categoryId: string) {
    return values.some((value) => value === categoryId);
  }

}
